import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-horizontal-stacked-bar-chart',
  templateUrl: './horizontal-stacked-bar-chart.component.html',
  styleUrls: ['./horizontal-stacked-bar-chart.component.scss']
})
/**
 * styling of Vertical stacked bar chart
 */
export class HorizontalStackedBarChartComponent  {
  publicSingle: any[] | undefined;
  publicMulti: any[] | undefined;

  name = 'Angular';
  width: number = 700;
  height: number = 300;
  fitContainer: boolean = false;

  view: any = [600, 400];
  showXAxis = true;
  showYAxis = true;
  gradient = true;
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabel = 'YAxis';
  showYAxisLabel = true;
  yAxisLabel = 'XAxis';
  timeline = true;
  doughnut = true;
  colorScheme : any = {
    domain: ['#9370DB', '#87CEFA', '#FA8072', '#FF7F50', '#90EE90', '#9370DB']
  };
  //pie
  showLabels = true;
  // data goes here for single bars
public single = [
  {
    "name": "China",
    "value": 2243772
  },
  {
    "name": "USA",
    "value": 1126000
  },
  {
    "name": "Norway",
    "value": 296215
  },
  {
    "name": "Japan",
    "value": 257363
  },
  {
    "name": "Germany",
    "value": 196750
  },
  {
    "name": "France",
    "value": 204617
  }
];
/**data goes here for multi bars */
public multi = [
  {
    "name": "Pipeline",
    "series": [
      {
        "name": "2018",
        "value": 26
      },
      {
        "name": "2017",
        "value": 34
      },
      {
        "name": "2016",
        "value": 40
      }
    ]
  },
]
}

